import { Grid, TextField } from '@achieve/ascend'
import { Typography } from 'components/Typography'
import { useReducer } from 'react'
const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_VALUE':
      return { ...state, valueForm: action.payload, userHasInteracted: true }
    default:
      return state
  }
}

export const FormTextInput = ({
  placeholder = 'Enter amount',
  disable = true,
  showTitle = true,
  title = 'What is your monthly gross income',
  titleComponent = 'div',
  titleWeight = 'regular',
  initialValue = 0,
  minValue = 0,
  maxValue = 0,
  onChange = () => {},
  enableSubmit = () => {},
  ...props
}) => {
  const [state, dispatch] = useReducer(reducer, {
    valueForm: initialValue,
    userHasInteracted: false,
  })
  const { valueForm, userHasInteracted } = state

  const formatValue = (value) => {
    return `$${value.toLocaleString()}`
  }

  const parseValue = (value) => {
    return parseFloat(value.replace(/[^0-9.-]+/g, '')) || 0
  }

  const changeValue = (value) => {
    let numericValue = parseValue(value)

    if (numericValue < minValue) {
      numericValue = minValue
    } else if (maxValue && numericValue > maxValue) {
      numericValue = maxValue
    }

    dispatch({ type: 'SET_VALUE', payload: numericValue })
    onChange(numericValue)

    if (value === '') {
      enableSubmit(false)
    } else {
      enableSubmit(true)
    }
  }

  return (
    <Grid item>
      <Grid container alignItems="center" justifyContent="space-between" marginBottom={1}>
        {showTitle && (
          <Grid item>
            <Typography
              className="flex"
              component={titleComponent}
              variant="bodyMd"
              fontWeight={titleWeight}
              data-testid={props?.['data-testid'] + '-title' || 'form-input-title'}
            >
              {title}
              {props?.tooltipComponent && props.tooltipComponent}
            </Typography>
          </Grid>
        )}
      </Grid>

      <>
        <div>
          <TextField
            className="max-w-full lg:max-w-[430px] form-input-container"
            variant="outlined"
            placeholder={placeholder}
            disabled={disable}
            fullWidth
            value={userHasInteracted ? formatValue(valueForm) : ''}
            onChange={(e) => {
              changeValue(e.target.value)
            }}
            data-testid={props?.['data-testid'] || 'form-input'}
          />
        </div>
      </>
    </Grid>
  )
}
